import { TopSkilledEmpDto } from "../../dtos/dashboard/TopSkilledEmpDto";
import { GetAllEmpInputDto } from "../../dtos/employee/GetAllEmpInputDto";
import { GetEmployeesBySubordinatesDto } from "../../dtos/employee/GetEmployeesBySubordinatesDto";
import { get, post } from "../../utills/BaseService";


export async function getAllEmployeesWithPagination(dispatch: any, details: GetAllEmpInputDto) {
    return await get(dispatch, '/employee/getAllEmployeesWithPagination', details);
};

export async function getSubordinates(dispatch: any) {
    return await get(dispatch, '/employee/getSubordinates', null);
};

export async function getSubordinatesByStatus(dispatch: any, Status: any) {
    return await get(dispatch, '/employee/getSubordinatesByStatus', Status);
};

export async function getAllSupervisors(dispatch: any) {
    return await get(dispatch, '/employee/getAllSupervisors', null);
};
export async function getEmployeesBySupervisors(dispatch: any,input:GetEmployeesBySubordinatesDto) {
    return await post(dispatch, '/employee/getEmployeesBySupervisors', input);
};
export async function getSubordinatesNameIDCode(dispatch: any) {
    return await get(dispatch, '/employee/getSubordinatesNameIDCode', null);
};
export async function getEmployeeDetailsByAccess(dispatch: any) {
    return await get(dispatch, '/employee/getEmployeeDetailsByAccess', null);
};

export async function getTopSkilledEmployees(dispatch: any, input: TopSkilledEmpDto): Promise<any> {
    return await get(dispatch, '/employee/getTopSkilledEmployees', input);
 };